<template>
  <h2 class="entry-title">{{ stateName }}</h2>

  <!-- <p>Introduction section</p>

  <p> This is some more test</p> -->

  <h3 v-if="data?.State">
    {{ data.State }}
  </h3>

  <p v-if="data.year_data_last_updated">
  This data was last updated in {{ data.year_data_last_updated }}.</p>

  <div v-for="gslug in group_display">
    <h4>{{ glabels[gslug] }}</h4>

    <div class="section">
      <div v-for="column in groups[gslug]">
        <card class="my-3 mx-auto" :name="describe(column, gslug)">
          <template #header>
            <span v-if="dictLookup(column, gslug)">
              {{ describe(column, gslug) }}
            </span>
          </template>
          {{ decode(column, gslug) }}
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "../components/Card.vue";
import { visible_sections } from "../lib/project";
export default {
  components: { Card },
  inheritAttrs: false,
  props: ["data", "dict", "groups", "stateName", "glabels"],
  data() {
    return {
      group_display: visible_sections,
    };
  },
  methods: {
    dictLookup(term, section) {
      let lookup = this.dict?.[section]?.find(field => field.label === term) ?? null;
      return lookup;
    },
    decode(term, section) {
      let lookup = this.dict?.[section]?.find(field => field.label === term) ?? null;
      return lookup?.coding?.[this.data[term]] ?? this.data[term];
    },
    describe(term, section) {
      let lookup = this.dict?.[section]?.find(field => field.label === term) ?? null;
      return lookup?.name ?? term;
    },
  },
};
</script>

<style></style>